export default __webpack_public_path__ + "static/media/opencart.c81ec7b7.svg";